<template>
  <div ref="viewBox" class="all">
    <!-- 编辑组件 -->
    <div v-show="!addVotingShow">
      <el-dialog
        class="release-dialog"
        :visible.sync="confirmDialogVisible"
        :show-close="false"
        :center="true"
        width="376px"
      >
        <div />
        <div class="disable">已使用外部编辑器，保存后，正文内容将被删除</div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="confirmDialogVisible = false">取 消</el-button>
          <el-button
            type="primary"
            @click="
              confirmDialogVisible = false;
              submitForm('form');
            "
          >
            确 定
          </el-button>
        </span>
      </el-dialog>
      <!-- <div class="box-header">
        <div class="header-back" @click="goBack()">
          <i class="el-icon-arrow-left" />
          返回
        </div>
      </div> -->
      <div class="box-bg">
        <div class="box-bar">
          <div class="bar-bg bar-left">
            <div class="bar-item" @click="openImage">图片</div>
          </div>
          <div class="bar-bg bar-left">
            <div class="bar-item" @click="openvideo">视频</div>
          </div>
          <div class="bar-bg bar-left">
            <div class="bar-item" @click="openmusic">音频</div>
          </div>
          <div class="bar-bg bar-center addVote">
            <div class="bar-item" @click="votling">投票</div>
            <articleJoinVote
              v-if="isSelectVoteShow"
              :list-ids="voteIds"
              @closeVote="closeVoteMe"
              @upSelectedVoteId="upSelectedVoteId"
              @newVoteId="newVoteId"
            />
          </div>
          <div class="bar-bg bar-left">
            <div class="bar-item" @click="openSMProgram">小程序</div>
          </div>
          <!--<div class="bar-bg bar-left">-->
          <!--  <div class="bar-item" @click="examdialog = true">考试</div>-->
          <!--</div>-->
          <div
            :class="{
              'bar-bgg': true,
              'bar-leftt': true,
              'checkbox-color': htmlCheckbox,
            }"
            style="width: 172px; padding: 0 15px; cursor: pointer"
          >
            <div class="box">
              <el-checkbox v-model="htmlCheckbox" @change="choiceHtml" class="log-ceckbox" />
              <div class="log-automatic" @click="openHtml">其他编辑器预览</div>
            </div>
          </div>
        </div>
      </div>
      <!-- 显示微信图片 -->
      <meta name="referrer" content="never" />
      <div v-loading="loading" class="box-body">
        <div class="body-edit">
          <quillEdit
            :title="title"
            :auth="auth"
            :video-list="videoList"
            :audio-list="audioList"
            :image-list="imageList"
            :content="content"
            :selected-vote-id="selectedVoteId"
            :selected-exam-id="selectedExamId"
            :sm-program-link="smProgramLink"
            @getAuthVal="getAuthVal"
            @getTitleVal="getTitleVal"
            @getContent="getContent"
          />
        </div>
        <div class="body-content">
          <div class="content">
            <div class="content-box">
              <div class="content-box-header content-box-header-top">封面</div>
              <div class="box-main">
                <el-upload
                  style="width: 188px; height: 80px"
                  :disabled="true"
                  class="avatar-uploader"
                  action="https://jsonplaceholder.typicode.com/posts/"
                  :show-file-list="false"
                  :on-success="handleAvatarSuccess"
                  :before-upload="beforeAvatarUpload"
                >
                  <img
                    v-if="imageUrl2"
                    alt=""
                    :src="imageUrl2"
                    class="avatar"
                    @click="selectImg2"
                  />
                  <i v-else class="el-icon-plus avatar-uploader-icon" @click="selectImg2">
                    <span class="upload-word" @click="selectImg2">选择封面</span>
                  </i>
                </el-upload>
                <div style="width: 15px"></div>
                <el-upload
                  style="width: 80px; height: 80px"
                  :disabled="true"
                  class="avatar-uploader"
                  action="https://jsonplaceholder.typicode.com/posts/"
                  :show-file-list="false"
                  :on-success="handleAvatarSuccess"
                  :before-upload="beforeAvatarUpload"
                >
                  <img v-if="imageUrl" alt="" :src="imageUrl" class="avatar" @click="selectImg" />
                  <i v-else class="el-icon-plus avatar-uploader-icon" @click="selectImg">
                    <span class="upload-word" @click="selectImg">选择封面</span>
                  </i>
                </el-upload>
              </div>
              <div class="hint-img" style="color: #a5a5a5; margin-top: 10px">
                推荐列表封面尺寸80px*188px，文章封面尺寸80px*80px
              </div>
              <!-- <div class="content-box-header margin-top">原创：{{declaration}}</div>
                        <div class="box-main">
                            <div class="declaration" @click="openDeclaration">声明原创</div>
                        </div> -->
              <div class="content-box-header margin-top">摘要</div>
              <div class="box-main">
                <div class="input-box">
                  <el-input
                    type="textarea"
                    :value="textarea"
                    class="avatar-word"
                    :maxlength="120"
                    show-word-limit
                    placeholder="选填，摘要会在订阅号消息、转发链接等文章外的场景显露，帮助读者快速了解内容，如不填写则默认抓取正文前54字"
                    clearable
                    @input="getTextareaVal"
                  />
                </div>
              </div>
              <div class="content-box-header margin-top">文章设置</div>
              <div class="box-main">
                <el-popover
                  placement="top"
                  popper-class="address-popover"
                  width="800"
                  v-model="oldAddressVisible"
                  trigger="manual"
                >
                  <div class="popover-box">
                    <div class="popover-title">原文链接</div>
                    <el-input
                      v-model="address"
                      class="popover-input"
                      placeholder="请输入原文链接"
                      clearable
                    />
                    <div class="popover-footer">
                      <el-button @click="OldAddressCancel">取消</el-button>
                      <el-button type="primary" @click="OldAddressConfirm">确认</el-button>
                    </div>
                  </div>
                  <div slot="reference" class="article-settings" @click="openOldAddress">
                    <img
                      v-if="oldAddress"
                      @click="choiceOldAddress"
                      class="article-choice"
                      :src="g_imgSrc.selectBlue"
                    />
                    <img
                      v-if="!oldAddress"
                      alt=""
                      class="article-choice"
                      :src="g_imgSrc.webUnSelected"
                      @click="choiceOldAddress"
                    />
                    <!-- <span class="old-address">原文链接</span> -->
                    <div class="old-address">原文链接</div>
                    <i class="el-icon-arrow-right" />
                    <span v-if="oldAddress" class="address">{{ OldaddressText }}</span>
                  </div>
                </el-popover>
              </div>
              <div class="content-box-header margin-top">文章类型</div>

              <tags v-if="false" />
              <div class="box-main">
                <el-form ref="form" :model="form" label-width="96px" class="edit-form">
                  <!--动态标签选择-->
                  <LabelSelect :tags="form.tags" ref="labelSelect"></LabelSelect>

                  <!-- 关联文档 -->
                  <DocLabel v-model="docList"></DocLabel>

                  <div class="content-box-header margin-top-purview">
                    查看权限
                    <el-popover
                      placement="top-start"
                      width="324"
                      trigger="hover"
                      content="该权限设定仅针对小程序或通过该文章外部链接访问时生效"
                    >
                      <img
                        slot="reference"
                        src="https://baike-med-1256891581.file.myqcloud.com/2021058/6dc96a10-b6be-11eb-9f82-2f36b21da993_0.png"
                        class="icon-wenhao"
                        alt=""
                      />
                    </el-popover>
                  </div>
                  <div class="box-main">
                    <div class="authority-box">
                      <div class="authority-box-part" @click="changeShowPermission(0)">
                        <el-radio v-model="show_permission" :label="0">仅注册用户可见</el-radio>
                      </div>
                      <div class="authority-box-part" @click="changeShowPermission(1)">
                        <el-radio v-model="show_permission" :label="1">全部用户可见</el-radio>
                      </div>
                      <div class="authority-box-part" @click="changeShowPermission(2)">
                        <el-radio v-model="show_permission" :label="2">仅代表可见</el-radio>
                      </div>
                    </div>
                  </div>
                  <div class="content-box-header margin-top-purview">评论设置</div>
                  <div class="box-main column">
                    <div class="comment-box">
                      <div class="comment-type">
                        <div class="comment-word">评论开关</div>
                      </div>
                      <div class="comment-box-part">
                        <el-radio v-model="commentControl.OpenComment" :label="false">
                          关闭评论
                        </el-radio>
                      </div>
                      <div class="comment-box-part">
                        <el-radio v-model="commentControl.OpenComment" :label="true">
                          打开评论
                        </el-radio>
                      </div>
                    </div>
                    <div class="comment-box">
                      <div class="comment-type">
                        <div class="comment-word">评论审核</div>
                      </div>
                      <div class="comment-box-part">
                        <el-checkbox
                          v-model="commentControl.DefaultPass"
                          :disabled="!commentControl.OpenComment"
                        >
                          默认通过审核
                        </el-checkbox>
                      </div>
                    </div>
                  </div>
                  <el-row>
                    <el-col :span="24">
                      <el-form-item label="有效时间:" class="edit-label weight-blod" prop="date1">
                        <el-date-picker
                          v-model="form.date1"
                          :unlink-panels="true"
                          type="daterange"
                          :editable="false"
                          range-separator="-"
                          value-formate="timestamp"
                          start-placeholder="开始日期"
                          end-placeholder="结束日期"
                        />
                        <span style="color: #b2b4b8; padding-left: 20px">{{ dateTip }}</span>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <div class="content-box-header margin-top-purview">审批码</div>
                  <div class="box-main">
                    <el-input
                      type="text"
                      placeholder="请输入内容"
                      v-model="approval_code"
                      maxlength="50"
                      show-word-limit
                    />
                  </div>
                </el-form>
              </div>
            </div>
          </div>
          <div class="body-content-footer">
            <div class="textCount">
              {{ '正文字数 ' + (textCount ? textCount : 0) }}
            </div>
            <!-- <div class="saveAll" style="width:200px">保存并发布到小程序</div> -->
            <div class="saveAll" @click="examine">保存</div>
          </div>
        </div>
      </div>
      <div class="suspend-btn" @click="goTop">
        <img
          :class="{
            'suspend-icon': true,
            'scroll-img-down': !scrollUp,
            'scroll-img-up': scrollUp,
          }"
          :src="g_imgSrc.back"
        />
        <div class="suspend-word">
          {{ scrollUp ? '返回顶部' : '文章设置' }}
        </div>
      </div>
      <el-dialog
        v-if="dialogVisible"
        class="release-dialog"
        :visible.sync="dialogVisible"
        :show-close="false"
        width="990px"
      >
        <imgdialog
          :imgclose="closeimg"
          @imgDatalist="imgSubmit"
          :img-id-list="imgIdList"
          type="public"
        />
      </el-dialog>
      <el-dialog
        v-if="musicdialog"
        class="release-dialog"
        :visible.sync="musicdialog"
        :show-close="false"
        width="968px"
      >
        <musicdialog :music-close="colseMusic" @musicDatalist="musicSubmit" type="public" />
      </el-dialog>

      <el-dialog
        class="release-dialog"
        :visible.sync="SMProgramDialog"
        :show-close="false"
        width="968px"
      >
        <SMProgramComp :dialog-close="closeSMProgram" @emitSubmit="SMProgramSubmit" type="public" />
      </el-dialog>

      <el-dialog
        v-if="videodialog"
        class="release-dialog"
        :visible.sync="videodialog"
        :show-close="false"
        width="968px"
      >
        <videodialog :video-close="closeVideo" @videoDatalist="videoSubmit" type="public" />
      </el-dialog>
      <el-dialog
        v-if="examdialog"
        class="release-dialog"
        :visible.sync="examdialog"
        :show-close="true"
        width="968px"
      >
        <Examination @examination="examination" />
      </el-dialog>
      <el-dialog
        v-if="selectImgVisible"
        class="release-dialog"
        :visible.sync="selectImgVisible"
        :show-close="false"
        width="990px"
      >
        <selectImg
          :select-imgclose="closeSelectimg"
          @selectimgDatalist="selectImgSubmit"
          type="public"
        />
      </el-dialog>
      <el-dialog
        class="release-dialog othor-editor"
        :visible.sync="htmldialog"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :show-close="true"
        width="750px"
      >
        <div slot="title" class="dialog-footer">外部编辑器</div>
        <div v-show="htmldialogLoading" class="ui-editor-progress">
          <el-progress :percentage="percentage" status="success" />
        </div>
        <div v-loading="htmldialogLoading">
          <uEditor v-model="htmlText" />
        </div>
        <div slot="footer" class="dialog-footer">
          <div class="footer-content">
            <el-button
              type="text"
              :disabled="htmldialogLoading || isClearButtonDisable"
              @click="htmldialogClear"
              style="color: #343536"
            >
              清 空
            </el-button>
            <div class="html-btn">
              <el-button :disabled="htmldialogLoading" @click="htmldialogCancel" plain>
                取 消
              </el-button>
              <el-button type="primary" @click="htmldialogConfirm" :disabled="htmldialogLoading">
                保 存
              </el-button>
            </div>
          </div>
        </div>
      </el-dialog>
      <el-dialog
        class="dialog-public"
        title="素材使用情况"
        :visible.sync="publicVisible"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :show-close="true"
        center
      >
        <div class="public-dialog-body">
          <h4 v-if="originArr.length">
            根据所选素材，文章标题1适用公众号为:
            <span v-for="(item, index) in originArr" :key="index">
              {{ index ? '、' : '' }}{{ item.app_name }}
            </span>
          </h4>
          <h4 v-else>文章适用公众号：无适用公众号</h4>
          <h4>{{ title }}</h4>
          <el-table :data="show_media_id" stripe style="width: 100%">
            <el-table-column prop="date" label="素材">
              <template slot-scope="scope">
                <img v-if="scope.row.mate_type === 1" :src="scope.row.mate_data" alt="" />
                <video v-if="scope.row.mate_type === 2" :src="scope.row.mate_data"></video>
              </template>
            </el-table-column>
            <el-table-column prop="mate_name" label=""></el-table-column>
            <el-table-column prop="address" label="适用公众号">
              <template slot-scope="scope">
                <p v-for="it in scope.row.public_list" :key="it.app_id" class="public-list">
                  {{ it.app_name }}
                </p>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div slot="title" style="width: 100%; text-align: start">
          <h4>素材使用情况</h4>
        </div>
        <span slot="footer" class="dialog-footer my-dialog-footer">
          <el-button @click="closeConfirmForm" :loading="dialogPublicLoading">取消</el-button>
          <el-button type="primary" @click="confirmForm('form')" :loading="dialogPublicLoading">
            确 认
          </el-button>
        </span>
      </el-dialog>
    </div>
    <!-- 编辑器素材选择公众号弹框 -->
    <UserPublic
      isedit
      :public-value="selectPublics"
      :dialog-visible.sync="showPubliclist"
      @emitUserPublic="emitUserPublic"
    />
    <!-- 新建投票 -->
    <AddVotingComp v-if="addVotingShow" :row="{}" @addVotingShowEmit="addVotingShowEmit" />
    <!-- 展示删除的素材 -->
    <showDeleteMate
      :show="isShowDlete"
      :data="[show_media_list]"
      @close="closeShowMedia"
      @affirm="affirmShowMedia"
      type="edit"
    />
  </div>
</template>

<script>
import chunk from 'lodash/chunk';
import { arrUnique } from '@/utils/util';
import { CosMixin } from '@/mixins/cos';
import quillEdit from '@/components/quillEditor';
import UserPublic from '@/components/user-public/index';
import LabelSelect from '@/components/labelSelect';
import imgdialog from './components/dialog.vue';
// import _ from 'lodash';
import musicdialog from './components/music.vue';
import videodialog from './components/video.vue';
import SMProgramComp from './components/smProgram.vue';
import tags from './components/tags.vue';
import selectImg from '@/components/selectimg';
import uEditor from '@/components/uEditor';
import showDeleteMate from './components/showDeleteMate';
import DocLabel from './components/docLabel';
import { timeStampOne } from '@/utils/time';
import { urlToFile } from '@/utils/getImgFile';
import articleJoinVote from './articleJoinVote';
import AddVotingComp from '@/views/voteManagement/addVoting';
import { getHospitalDepartmentListApi } from '@/api/setUp.js';
import { GetLabelInfoList, GetProductInfoList } from '@/api/setUser.js';
import {
  AddArticleResApi,
  EyaoSaaSSynCreateMaterialApi,
  GetArticleByIDApi,
  getDeletedMediaListApi,
  UpdArticleResApi,
} from '@/api/releaseManagement.js';
import Examination from './components/examination.vue';

const PASTE_NOTICE = '';

export default {
  name: 'ArticleEdit',
  components: {
    quillEdit,
    imgdialog,
    musicdialog,
    videodialog,
    SMProgramComp,
    selectImg,
    uEditor,
    articleJoinVote,
    AddVotingComp,
    UserPublic,
    showDeleteMate,
    DocLabel,
    tags,
    LabelSelect,
    Examination,
  },
  mixins: [CosMixin],
  data() {
    return {
      editId: null, // 文章iD
      confirmDialogVisible: false,
      totalCount: 0,
      successCount: 0,
      title: '', // 标题
      auth: '', // 作者
      content: '', // 编辑器内容
      showPubliclist: false,
      selectPublics: [], // 选择的公众号
      selectagentList: [], // 选择的微信应用
      imageUrl: '', // 头条封面
      imageUrl2: '', // 列表封面
      cover_media_id: [{}, {}], // 封面素材使用情况
      content_media_id: [], // 正文素材使用情况

      deleted_media: {}, // 删除的素材集合
      media_info: {}, // 文章所有素材最新信息
      show_media_list: { deleted_media: [] }, // 需要展示的删除了的素材集合
      isShowDlete: false, // 是否展示删除素材

      show_media_id: [], // 展示的素材
      isShowMedia: true, // 是否展示素材列表(所有素材的公众号都相同时不展示)
      textarea: '', // 摘要
      textarea_backups: '', // 摘要(正文截取)
      textareaCount: 0, // 摘要字数
      declaration: '未声明', // 声明
      // 原文地址
      address: '', // 输入的原文地址
      OldaddressText: '', // 展示的原文地址
      oldAddress: false, // 原文地址选择
      oldAddressVisible: false, // 填写原文地址弹窗
      productList: [], // 产品列表
      departmentList: [], //  科室列表
      diseaseList: [], //  疾病列表
      promoteList: [], //  推广列表
      otherTagList: [], // 其他分类列表
      // isAuthorityAll: false, // 是否全部用户可见
      status: 3, // 消息状态
      textCount: 0, // 正文字数
      disblockimg: false,
      create_time: 0, // 创建时间
      update_time: 0, // 修改时间
      form: {
        product: [],
        department: [],
        disease: [],
        promote: [],
        otherTag: [],
        date1: [],
      },
      labelList: [],
      labelCheckList: [],
      dialogLabelManageVisible: false, // 标签管理的dialog
      approval_code: '',
      rules: {
        product: [{ required: true, message: '请选择产品', trigger: 'change' }],
        // date1: [{ required: true, message: "请选择日期", trigger: "change" }],
      },
      imgData: [], // 添加了灰色标识的数组
      sortList: [], // 勾选为true的数组
      loading: false,
      dialogVisible: false, // 图片的dialog
      musicdialog: false, // 音频的dialog
      videodialog: false, // 视频的dialog
      examdialog: false, // 考试的dialog
      SMProgramDialog: false, // 小程序的dialog
      htmldialog: false,
      htmlType: 0, // 0:本地html，1：秀米内容
      imageList: [],
      videoList: [],
      audioList: [],
      selectImgVisible: false,
      coverType: 0, // 1:文章封面 2.列表封面
      scrollUp: false, // 控制悬浮按钮
      appTextObj: {}, // 配对放置cos和公众号的链接
      wechatObj: [],
      editStyle: {
        'class="ql-indent-1"': 'style="padding-left: 3em;"',
        'class="ql-indent-2"': 'style="padding-left: 6em;"',
        'class="ql-indent-3"': 'style="padding-left: 9em;"',
        'class="ql-indent-4"': 'style="padding-left: 12em;"',
        'class="ql-indent-5"': 'style="padding-left: 15em;"',
        'class="ql-indent-6"': 'style="padding-left: 18em;"',
        'class="ql-indent-7"': 'style="padding-left: 21em;"',
        'class="ql-indent-8"': 'style="padding-left: 24em;"',
        '<ol>': '<ol style="padding-left: 1.5em;">',
      }, // 改变edit的class为style内联
      htmlText: PASTE_NOTICE,
      saveHtmlText: PASTE_NOTICE /* 保存文本 */,
      htmlCheckbox: false, // 勾选秀米 其他编辑器预览
      htmldialogLoading: false,
      haveBadImg: false, // 是否含有未上传成功的照片
      // isOnly: null,
      // isAll: null,
      show_permission: 0, // 0:仅注册用户可见 1:全部用户可见 2:仅代表可见
      isSelectVoteShow: false /* 选择投票弹窗 */,
      selectedVoteId: '' /* 选中的投票id */,
      hrefOrVote: '' /* 原文链接或者用户调研 */,
      voteIds: [] /* 投票ID集合 */,
      publicVisible: false, // 素材使用情况弹窗
      originArr: [], // 文章适用公众号数组
      imgIdList: [], // 編輯器內圖片id
      useWechatList: [], // 文章内素材使用列表
      dialogPublicLoading: false, // 发布确认弹窗按钮加载动画
      contentText: '', // 富文本里的纯文字
      uploadShow: false, // 上传素材
      addVotingShow: false, // 新建投票
      docDialogVisible: false, // 添加关联文档
      commentControl: {
        OpenComment: false, // false:关闭评论 true:打开评论
        DefaultPass: false, // 默认通过审核
      },
      trigger: false,
      docList: [], // 关联文档
      selectedExamId: '', // 考卷id
      paperId: '', // 考卷id
      smProgramLink: {}, // 小程序跳转参数
    };
  },
  computed: {
    publicList() {
      return this.$store.getters['user/getPublishList'];
    },
    percentage() {
      if (this.totalCount > 0) {
        return Math.min(1, this.successCount / this.totalCount) * 100;
      }
      return 0;
    },
    dateTip() {
      if (this.form.date1 && this.form.date1[0] && this.form.date1[1]) {
        const timeStamp1 = this.form.date1[0].getTime();
        const timeStamp2 = this.form.date1[1].getTime();
        const start = `${timeStampOne(timeStamp1, 'year')}-${timeStampOne(
          timeStamp1,
          'month',
        )}-${timeStampOne(timeStamp1, 'day')}`;
        const end = `${timeStampOne(timeStamp2, 'year')}-${timeStampOne(
          timeStamp2,
          'month',
        )}-${timeStampOne(timeStamp2, 'day')}`;
        return `${start}自动上架 ${end}自动下架`;
      }
      return '';
    },
    isClearButtonDisable() {
      return this.htmlText.replace(/&nbsp;/g, '').trim() === '';
    },
  },
  watch: {
    'commentControl.OpenComment'(newVal) {
      if (!newVal) {
        this.commentControl.DefaultPass = false;
      }
    },
  },
  created() {
    this.selectPublics = this.publicList.map((item) => {
      return {
        label: item.app_name,
        value: item.app_id,
      };
    });
    // 查询微信应用列表
    const agentList = this.$store.state.user.managerLogin.agent_list;
    this.selectagentList = agentList.map((item) => {
      return {
        label: item.app_name,
        value: item.agent_id,
      };
    });

    if (this.htmlText.trim() === '') {
      this.htmlText = PASTE_NOTICE;
    }
    const { query } = this.$route;
    let title = '新建文章';
    if (query.id) {
      title = '编辑文章';
      this.editId = query.id;
      // 编辑页
      this.getAllQueryPageTag();
      this.getMessageInfo(this.editId);
      this.getDeleteList(this.editId);
    } else {
      // 新建页
      this.getAllQueryPageTag();
    }

    // 设置面包屑
    const breadcrumb = [
      { menu_name: '发布管理', menu_path: '' },
      {
        menu_name: '内容管理',
        menu_path: 'articleManagement',
        menu_params: { componentName: 'articleList' },
      },
      {
        menu_name: '公众号文章列表',
        menu_path: 'articleManagement',
        menu_params: { componentName: 'articleList' },
      },
      { menu_name: title },
    ];

    this.$store.commit('user/setBreadcrumb', breadcrumb);
  },
  mounted() {
    this.listenerAction();
  },
  methods: {
    // 试卷选择
    examination(val) {
      const { paper_id: paperId } = val[0];
      console.log(paperId, this.selectedExamId, '试卷选择');
      if (this.content.includes('<span style="color: rgb(0, 129, 204);">[考卷:')) {
        this.$message('只能添加一份考卷, 请删除后添加');
        return;
      }
      this.examdialog = false;
      this.selectedExamId = paperId;
      this.paperId = paperId;
      setTimeout(() => {
        this.selectedExamId = '';
      }, 600);
    },
    // 判断是否选择了禁用值
    getSelectStatus(selectId, options, key) {
      let status = 1;
      options.forEach((el) => {
        if (el[key] === selectId) {
          status = el.status;
        }
      });
      return status !== 1;
    },
    // 获取删除的素材列表
    async getDeleteList(id) {
      const res = await getDeletedMediaListApi({ art_ids: [id], art_type: 1 });

      const mediaInfo = res.maps[id] ? res.maps[id].media_info : {};
      if (JSON.stringify(mediaInfo) !== '{}') {
        mediaInfo.forEach((item) => {
          this.media_info[item.id] = item;
        });
      }
      const deletedMedia = res.maps[id] ? res.maps[id].deleted_media : {};
      if (JSON.stringify(deletedMedia) !== '{}') {
        this.show_media_list.deleted_media = deletedMedia;
        deletedMedia.forEach((item) => {
          this.deleted_media[item.mate_id] = item;
        });
      }
    },
    // 获取素材信息(图片)
    getMaterialInfo() {
      // 获取素材列表
      let materialArr0 = [...this.cover_media_id, ...this.content_media_id];
      // 去重
      materialArr0 = arrUnique(materialArr0, 'id');
      // 更新最新信息
      materialArr0 = materialArr0.map((item) => {
        if (!!this.media_info[item.id]) {
          return this.media_info[item.id];
        }
        return item;
      });
      // 去除默认值{}
      materialArr0 = materialArr0.map((item) => {
        const obj = JSON.parse(JSON.stringify(item));
        if (JSON.stringify(item.public_list) === '{}' || !item.public_list) {
          obj.public_list = [];
        }
        return obj;
      });
      // 去除删除素材
      const materialArr = [];
      for (let index = 0; index < materialArr0.length; index++) {
        const ele = materialArr0[index];
        if (!this.deleted_media[ele.id]) {
          materialArr.push(ele);
        }
      }

      this.show_media_id = materialArr;

      if (this.show_media_id.length <= 0) {
        this.originArr = [];
        return;
      }
      // 判断所有素材的公众号是否相同
      let applist = this.show_media_id.map((item) => {
        return JSON.stringify(
          item.public_list.map((item) => {
            return item.app_id;
          }),
        );
      });
      applist = arrUnique(applist);
      if (applist.length === 1) {
        // 不显示相同公众号
        this.isShowMedia = false;
      }
      // 获取相同的公众号(交集)
      this.originArr = JSON.parse(JSON.stringify(this.cover_media_id[0].public_list));
      for (let i = 0; i < materialArr.length; i++) {
        this.originArr = this.originArr.filter((el) =>
          materialArr[i].public_list.some((y) => el.app_id === y.app_id),
        );
        if (this.originArr.length === 0) {
          break;
        }
      }
      // 判断是否含有删除的素材
      const deleteMedia = [];
      materialArr0.forEach((item) => {
        if (!!this.deleted_media[item.id]) {
          deleteMedia.push(this.deleted_media[item.id]);
        }
      });
      this.show_media_list.deleted_media = deleteMedia;
    },
    // 获取页面素材使用情况列表(图片)
    getPublicInfo(htmlType) {
      // 注意: 外编辑器弹窗只有打开一次以后才能获取dom信息
      const str = htmlType ? 'div.othor-editor img' : '.quill-editor img';
      const imgArr = document.querySelectorAll(str);
      imgArr.forEach((item) => {
        item.mate_type = 1;
      });
      // console.log(this.videoList);
      // this.videoList.forEach((item) => {
      //   item.mate_type = 2;
      // });
      // console.log(this.audioList);
      // this.audioList.forEach((item) => {
      //   item.mate_type = 3;
      // });
      let videoNode = [];
      let audioNode = [];
      if (!htmlType) {
        videoNode = document.querySelectorAll('.quill-editor .ql-video');
        videoNode.forEach((item) => {
          item.mate_type = 2;
        });
        audioNode = document.querySelectorAll('.quill-editor .audio');
        audioNode.forEach((item) => {
          item.mate_type = 3;
        });
      }
      // console.log('videoNode');
      // console.log(videoNode);
      // console.log('audioNode');
      // console.log(audioNode);
      // const nodeArr = [...imgArr, ...this.audioList, ...this.videoList];
      const nodeArr = [...imgArr, ...audioNode, ...videoNode];

      const attrArr = [];
      nodeArr.forEach((item) => {
        // const id = item.getAttribute('mate_id');
        // const mateData = item.getAttribute('mate_data');
        // const mateName = item.getAttribute('mate_name');
        const publicInfo = item.getAttribute('publicInfo');
        if (publicInfo) {
          attrArr.push({
            id: item.getAttribute('mate_id'),
            mate_data: item.src,
            mate_name: item.getAttribute('mate_name'),
            mate_type: item.mate_type,
            public_list: publicInfo ? JSON.parse(publicInfo) : [],
          });
        }
      });
      this.content_media_id = attrArr;
      console.log('attrArr');
      console.log(this.content_media_id);
      this.getMaterialInfo(); // 计算适用公众号
    },
    getAllQueryPageTag() {
      return Promise.all([
        // this.getQueryPageTag(10),
        // this.getQueryPageTag(20),
        // this.getQueryPageTag(30),
        this.getProductPageTag(),
        this.getHospitalDepartment(),
      ]);
    },
    change(obj) {
      console.log(obj);
      let amount = 0;
      for (const label of this.labelList) {
        amount += label.selectValue.length;
      }
      if (amount >= 20) {
        obj.pop();
        this.$message.warning('标签数量不能多于20个');
      }
    },
    sleep(ms) {
      return new Promise((resolve) => {
        setTimeout(resolve, ms);
      });
    },
    getImageFileFromUrl(url, fileName, callback) {
      let blob = null;
      const xhr = new XMLHttpRequest();
      xhr.open('GET', `${url}?time=${new Date().getTime()}`);
      xhr.setRequestHeader('Accept', 'image/jpeg');
      xhr.responseType = 'blob';
      xhr.onload = () => {
        if (xhr.status === 200) {
          blob = xhr.response;
          const imgFile = new File([blob], fileName, { type: 'image/jpeg' });
          callback.call(this, imgFile);
        }
      };
      xhr.send();
    },
    htmldialogConfirm() {
      // 判断是否含有照片
      // const imgArrNode = Object.values(document.querySelectorAll('div.othor-editor img'));
      const imgArrNode = Object.values(
        document.querySelector('.ui-editor').contentWindow.document.querySelectorAll('img'),
      );
      // console.log(
      //   document.querySelector('.ui-editor').contentWindow.document.querySelectorAll('img'),
      // );
      console.log(imgArrNode);
      const backgroudImg = /background-image:\s*url\(.*\)/.test(this.htmlText);
      console.log(backgroudImg);

      if (imgArrNode.length || backgroudImg) {
        this.showPubliclist = true;
      } else {
        this.htmldialogConfirm2([]);
      }
    },
    // 提交选择公众号
    emitUserPublic(e) {
      // const imgArrNode = Object.values(document.querySelectorAll('div.othor-editor img'));
      const imgArrNode = Object.values(
        document.querySelector('.ui-editor').contentWindow.document.querySelectorAll('img'),
      );

      this.selectPublics = e;
      if (this.selectPublics.length) {
        this.htmldialogConfirm2(imgArrNode);
      } else {
        this.$message('请至少选择一个公众号');
        this.showPubliclist = true;
      }
    },
    // 上传编辑器照片(外部编辑器照片)
    async htmldialogConfirm2(allImgArrNode) {
      this.htmldialogLoading = true;
      await this.sleep(1000);

      this.haveBadImg = false;
      // 过滤外部图片
      const imgArrNode = allImgArrNode.filter((item) => !item.getAttribute('publicInfo'));
      console.log('?', this.htmlText);
      const test = /background-image:\s*url\((&quot;|")(.*?)(&quot;|")\)/g;
      const backgroudImg = [];
      let temp = test.exec(this.htmlText);
      while (temp) {
        console.log(temp);
        backgroudImg.push(temp[2]);
        temp = test.exec(this.htmlText);
      }
      // console.log(backgroudImg);
      if (imgArrNode.length || backgroudImg.length) {
        // 获取图片地址
        const imgArr = imgArrNode.map((i) => ({
          src: i.src.replace('http:', 'https:'),
        }));
        imgArr.push(
          ...backgroudImg.map((i) => {
            return { src: i.replace('http:', 'https:') };
          }),
        );

        console.log('imgArr', imgArr);

        this.totalCount = imgArr.length;

        // 获取图片大小
        const result = await Promise.all(imgArr.map((i) => this.getImgSize(i.src)));
        const maxSize = 1024 * 1024 * 20;
        // 获取图片大小失败
        if (result.filter((i) => !i.success).length > 0) {
          // this.$message({
          //   message: `无法获取图片大小，有可能上传失败`,
          //   // message: `因跨域问题，无法获取图片大小: 有可能上传失败<br/> ${result
          //   // .filter((i) => i.size > maxSize).map(i=>`<br/ ><img width=200 src=${i.src} />`)} `,
          //   duration: 5000,
          // });
          this.loading = false;
          this.htmldialogLoading = false;
          this.haveBadImg = true;
          this.$aegis.report({
            msg: '图片信息获取失败',
          });
          this.$message('图片信息获取失败，无法保存，请先手动将图片上传到素材库后再使用');
          return;
        }
        // 验证图片大小，不能超过10M
        if (result.filter((i) => i.size > maxSize).length > 0) {
          // this.$message({
          //   dangerouslyUseHTMLString: true,
          //   message: `文件不能超过1M: <br/> ${result
          //     .filter((i) => i.size > maxSize)
          //     .map((i) => `<br/ ><img width=200 src=${i.src} />`)} `,
          //   duration: 5000,
          // });

          this.loading = false;
          this.htmldialogLoading = false;
          this.haveBadImg = true;
          this.$aegis.report({
            msg: '图片过大',
          });
          this.$message('图片过大，无法保存，请先手动将图片上传到素材库后再使用');
          return;
        }
        // 获取公众号列表
        const apps = this.selectPublics.map((item) => {
          return {
            app_id: item.value,
            app_name: item.label,
          };
        });
        // 获取微信应用列表
        // const agents = this.selectagentList.map((item) => {
        //   return {
        //     agent_id: item.value,
        //     app_name: item.label,
        //   };
        // });

        const imgdata = [];
        try {
          const oneImg = async (item) => {
            // cos上传
            const imgFile = await urlToFile(item.src, item.name);
            const res = await this.putCosObject({ fileObject: imgFile });
            return { data: res.data, name: item.name }; // 图片地址
          };
          const tempBox = [];
          for (const item of imgArr) {
            let imgName = item.src.substr(item.src.length - 12, 12); // 图片名
            if (imgName.indexOf('.') === -1) {
              imgName += '.jpg';
            }
            tempBox.push({ src: item.src, name: imgName });
          }
          const res = await Promise.all(
            tempBox.map((item) => {
              return oneImg(item);
            }),
          );
          for (const { data, name } of res) {
            imgdata.push({
              apps,
              agents: [],
              mate_data: data,
              mate_name: name, // 图片名
              mate_type: 1,
              sync_type: 1,
            });
          }
          // }
          console.log(imgdata);
          // 素材同步接口限制，20 个一组
          const imgdataChunks = chunk(imgdata, 10);
          let imgRes = [];
          for (let index1 = 0; index1 < imgdataChunks.length; index1++) {
            const imgdataChunk = imgdataChunks[index1];
            const res = await EyaoSaaSSynCreateMaterialApi({ mate_infos: imgdataChunk });
            imgRes = imgRes.concat(res.up_res);
          }
          imgArrNode.forEach((item, index) => {
            const imageUrl = imgdata[index].mate_data;
            const id = imgRes[index].mate_id;
            const url = imgRes[index].wx_media_url;
            const matName = imgdata[index].mate_name;
            let publicInfo = JSON.stringify(apps);
            publicInfo = publicInfo.replace(/[\r\n]/g, ''); // 去除空格和换行
            const style = item.getAttribute('style');
            console.log('style', style);
            const newImgNode = `<img src="${url}" style="${style}" referrerPolicy="no-referrer" mate_id="${id}" mate_data="${imageUrl}" mate_name="${matName}" publicInfo='${publicInfo}'/>`;
            const oldImgNode = item.outerHTML;

            this.htmlText = this.htmlText.replace(oldImgNode, newImgNode);
          });
          backgroudImg.forEach((item, index) => {
            const newNode = imgRes[index + imgArrNode.length].wx_media_url;
            console.log(item, newNode);
            this.htmlText = this.htmlText.replace(item, newNode);
          });
          // const res = await EyaoSaaSSynCreateMaterialApi({ mate_infos: imgdata });
          // // 替换页面img标签
          // imgArrNode.forEach((item, index) => {
          //   const imageUrl = imgdata[index].mate_data;
          //   const id = res.mate_id;
          //   const url = res.up_res[index].wx_media_url;
          //   const matName = imgdata[index].mate_name;
          //   let publicInfo = JSON.stringify(apps);
          //   publicInfo = publicInfo.replace(/[\r\n]/g, ''); // 去除空格和换行

          //   const newImgNode = `<img src="${url}" mate_id="${id}" mate_data="${imageUrl}" mate_name="${matName}" publicInfo='${publicInfo}'/>`;
          //   const oldImgNode = item.outerHTML;

          //   this.htmlText = this.htmlText.replace(oldImgNode, newImgNode);
          // });

          this.htmldialogLoading = false;
          this.$message('您已选择外部编辑器，上传内容将替换为外部编辑器内容');
          this.haveBadImg = false;
        } catch (err) {
          this.$aegis.report({
            msg: '素材同步失败',
          });
          this.htmldialogLoading = false;
          this.haveBadImg = true;
          this.$message('素材同步失败，请先手动将图片上传到素材库后再使用');
        }
        // this.appTextObj = Object.assign(
        //   this.appTextObj,
        //   imgdata.map((item) => {
        //     return item.mate_data;
        //   }),
        // );
      }

      this.htmldialogLoading = false;
      this.htmlType = 1;
      this.htmldialog = false;
      this.htmlCheckbox = true;
      this.saveHtmlText = this.htmlText;
      // 节点更新需时间,延时获取素材信息
      setTimeout(() => {
        this.getPublicInfo(1);
      }, 700);
    },
    uploadFile(item) {
      return new Promise((resolve, reject) => {
        const src = item.src.replace(/^http:/, 'https:');
        this.getImageFileFromUrl(
          src,
          `${src.substring(src.length - 20, src.length)}.jpg`,
          async (file) => {
            const result = await this.$upLoad(file);
            if (result && result.code === 0) {
              const obj = {};
              obj[item.src] = result.url;
              this.appTextObj = Object.assign(this.appTextObj, obj);
              resolve(result);
            } else {
              reject(item);
            }
          },
        );
      });
    },
    // 获取 <img src='' /> 的图片大小，解决https http 混用问题
    /**
     * imgTag：img tag， 不能传img.src !!!
     */
    getImgSize(src) {
      let requesturl = src;
      if (/\?\w=/.test(src)) {
        requesturl = `${src}&timestamp=${new Date().getTime()}`;
      } else {
        requesturl = `${src}?timestamp=${new Date().getTime()}`;
      }
      return new Promise((resolve) => {
        fetch(requesturl)
          .then((resp) => resp.blob())
          .then((b) =>
            resolve({
              size: b.size,
              src,
              success: 1,
            }),
          )
          .catch(() => {
            resolve({
              src,
              size: 0,
              success: 0,
            });
          });
      });
    },
    // 勾选其他编辑器预览
    choiceHtml(e) {
      if (e) {
        this.$message('您已选择外部编辑器，上传内容将替换为外部编辑器内容');
        this.htmlType = 1;
      } else {
        this.$message('您已取消外部编辑器，上传内容将替换为内部编辑器内容');
        this.htmlType = 0;
      }
    },
    /* 外部编辑器取消 */
    htmldialogCancel() {
      this.htmldialog = false;
      if (this.saveHtmlText) {
        this.htmlText = this.saveHtmlText;
      }
    },
    /* 外部编辑器清空 */
    htmldialogClear() {
      this.$confirm('确认清空编辑器里面的内容吗？', '', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.htmlText = '';
        })
        .catch(() => {});
    },
    listenerAction() {
      const box = this.$refs.viewBox;
      box.addEventListener('scroll', this.handleScroll, true);
    },
    handleScroll(e) {
      const { scrollTop } = e.target;
      if (scrollTop >= 780) {
        this.scrollUp = true;
      } else {
        this.scrollUp = false;
      }
    },
    // 获取标签
    getQueryPageTag(type) {
      const promise = new Promise(async (resolve, reject) => {
        const params = {
          label_type: type,
          page_index: 1,
          page_size: 9999,
        };
        const res = await GetLabelInfoList(params);
        // 标签类型，10-产品推广，20-疾病科普，30-其他分类
        // promoteList: [], //  推广列表
        // diseaseList: [], //  疾病列表
        // otherTagList: [], // 其他分类列表
        const data = res.list;
        if (type === 10) {
          this.promoteList = data;
        } else if (type === 20) {
          this.diseaseList = data;
        } else if (type === 30) {
          this.otherTagList = data;
        }

        if (res) {
          resolve(res);
        } else {
          reject(res);
        }
      });

      return promise;
    },
    // 获取产品标签
    getProductPageTag() {
      const promise = new Promise(async (resolve, reject) => {
        const params = {};
        const res = await GetProductInfoList(params);
        this.productList = res.list;

        if (res) {
          resolve(res);
        } else {
          reject(res);
        }
      });

      return promise;
    },
    // 获取科室信息
    getHospitalDepartment() {
      this.loading = true;
      // 获取科室列表
      getHospitalDepartmentListApi()
        .then((res) => {
          this.loading = false;
          this.departmentList = res.data;
        })
        .catch(() => {
          this.loading = false;
          this.$message('查询失败');
        });
    },
    // 获得文章详细信息
    getMessageInfo(id) {
      const req = { art_id: id };
      this.loading = true;
      GetArticleByIDApi(req)
        .then((res) => {
          const data = res.art_info;
          this.paperId = data.paper_id;
          this.title = data.title;
          this.show_media_list.id = id;
          this.show_media_list.title = data.title;
          this.auth = data.author;
          this.content =
            data.external_support_opt === 1
              ? ''
              : data.text.replace(
                  /<i voteId="(\S*)"><\/i>/gi,
                  '<span style="color: rgb(0, 129, 204);">[问卷调查:$1]</span>',
                );
          /* 获取内容中的投票ID集合 */
          this.voteIds =
            data.external_support_opt === 1
              ? []
              : data.text
                  .match(/<i voteId="(\S*)"><\/i>/gi)
                  ?.map((item) => item?.replace(/<i voteId="(\S*)"><\/i>/gi, '$1')) ?? [];
          this.saveHtmlText = data.external_support_opt === 1 ? data.text : '';
          this.htmlText = this.saveHtmlText;
          this.textCount = data.text_count;
          this.imageUrl = data.cover_url;
          this.imageUrl2 = data.cover_list_url;
          this.htmlType = data.external_support_opt;
          this.htmlCheckbox = data.external_support_opt === 1;
          if (data.cover_media_id && Array.isArray(JSON.parse(data.cover_media_id))) {
            this.cover_media_id = JSON.parse(data.cover_media_id); // 封面素材信息
          } else {
            this.cover_media_id = [{}, {}]; // 封面素材信息
          }
          this.content_media_id = data.content_media_id ? JSON.parse(data.content_media_id) : []; // 正文素材信息

          this.textarea = data.digest;
          this.textarea_backups = data.digest;
          this.textareaCount = data.digest ? data.digest.length : 0;
          if (data.content_source_url) {
            this.oldAddress = true;
            this.OldaddressText = data.content_source_url;
            this.address = data.content_source_url;
          }

          //   this.isAuthorityAll = Number(data.show_permission) === 1;
          //   this.isOnly = Number(data.show_permission) === 0 ? 2 : null;
          //   this.isAll = Number(data.show_permission) === 1 ? 1 : null;
          this.show_permission = Number(data.show_permission);
          this.appTextObj = data.cos_app_obj ? JSON.parse(data.cos_app_obj) : {};
          this.status = data.status;
          this.create_time = data.create_time;
          this.update_time = data.update_time;
          this.approval_code = data.approval_code;
          this.commentControl = data.Comment;
          // 标签类型，10-产品推广，20-疾病科普，30-其他分类

          // promoteList: [], //  推广列表
          // diseaseList: [], //  疾病列表
          // otherTagList: [], // 其他分类列表
          setTimeout(() => {
            // const product = [];
            // const department = [];
            // for (const tag of data.tags) {
            //   if (tag.TagType === 1) {
            //     product.push(tag.TagId);
            //   } else if (tag.TagType === 2) {
            //     department.push(String(tag.TagId));
            //   }
            // }
            this.form = {
              // product,
              // department,
              tags: data.tags,
              date1:
                Number(data.valid_time_start) === 0 && Number(data.valid_time_end) === 0
                  ? []
                  : [new Date(data.valid_time_start * 1000), new Date(data.valid_time_end * 1000)],
            };
          }, 600);
          this.docList = data.attachmentInfo;

          this.loading = false;
        })
        .catch((e) => {
          console.log('GetArticleByID', e);
          const { bizcode = 0 } = e;
          if (bizcode === 20008) {
            const url = `/saas/articleManagement.html`;
            this.g_tourl(url, {});
          }
          this.loading = false;
          this.$message('信息获取失败');
        });
    },
    getText() {
      return this.htmlType === 0 ? this.content : this.htmlText;
    },
    getAppText() {
      return this.htmlType === 0
        ? this.replaceText(this.content, this.appTextObj)
        : this.replaceText(this.htmlText, this.appTextObj);
    },
    // 检查编辑状态
    examine() {
      // if (this.show_permission === null) {
      //   this.$message('仅注册用户可见，全部用户可见两项至少选择一项');
      //   return false;
      // }

      if (!this.title) {
        this.$message('标题不能为空');
        return false;
      }
      if (this.htmlType === 1) {
        if (this.haveBadImg) {
          this.$aegis.report({
            msg: '存在不规范的图片',
          });
          this.$message('存在不规范的图片，无法保存，请先手动将图片上传到素材库后再使用');
          return false;
        }

        let str = this.htmlText.replace(/<!--EndFragment-->/g, '');
        str = str.replace(/[\r\n]/g, '');
        if (str === '') {
          this.$message('请填写正文内容');
          return false;
        }
        // if (this.contentText.length <= 0) {
        //   this.$message('正文必须有文字，请在正文至少输入1个汉字后重试');
        //   return false;
        // }
      } else {
        const str = '.quill-editor img';
        const imgArr = document.querySelectorAll(str);

        // 更新字数
        const val = document.querySelector('.ql-editor').innerText;
        const text = val.replace(/[\r\n]/g, '');
        this.textCount = text.length;

        if (this.textCount === 0) {
          if (imgArr.length === 0) {
            this.$message('请填写正文内容');
            return false;
          }
        }
      }
      if (this.content.includes('<img src="data:image/png;base64')) {
        this.$message('含有未上传至公众号的素材，请上传素材成功后，重新输入');
        return false;
      }
      if (!this.imageUrl2) {
        this.$message('列表封面必须插入一张图片');
        return false;
      }
      if (!this.imageUrl) {
        this.$message('文章封面必须插入一张图片');
        return false;
      }
      if (this.oldAddress && !this.OldaddressText) {
        this.$message('已选择原文链接，请输入完整');
        return false;
      }

      if (this.$refs.labelSelect.hasNoProduct()) {
        this.$message.warning('请至少选择一个产品标签');
        return false;
      }

      this.$refs.form.validate(async (valid) => {
        if (valid) {
          // 获取文章素材情况
          if (!this.htmlType) {
            this.getPublicInfo(this.htmlType);
          } else {
            this.getMaterialInfo();
          }
          // 判断是否展示删除的素材
          if (this.show_media_list.deleted_media.length !== 0) {
            this.isShowDlete = true;
            return false;
          }

          if (this.isShowMedia) {
            this.publicVisible = true;
          } else {
            this.confirmForm('form');
          }
        } else {
          this.$message('请填写完整信息');
          return false;
        }
      });
    },
    closeConfirmForm() {
      this.publicVisible = false;
    },
    confirmForm() {
      if (this.htmlType === 1) {
        this.confirmDialogVisible = true;
      } else {
        this.submitForm();
      }
    },
    // 提交
    async submitForm() {
      console.log('进入保存');
      this.disblockimg = true;
      // 如果选择同一天 时间范围是当天00:00:00-23:59:59
      let validTimeStart = '';
      let validTimeEnd = '';
      if (this.form.date1 && this.form.date1[0] && this.form.date1[1]) {
        validTimeStart = this.dateToMs(this.form.date1[0]);
        validTimeEnd = this.dateToMs(this.form.date1[1]);
        if (validTimeStart === validTimeEnd) {
          validTimeEnd = validTimeEnd + 86399;
        }
      }
      // 更新修改时间和创建时间
      if (!this.editId) {
        this.create_time = this.getNowTime();
      }
      this.update_time = this.getNowTime();

      // 判断是否含有投票
      let havevote = 0; // 0:不支持投票,1:支持投票
      const str = this.getText();
      if (str.indexOf('<span style="color: rgb(0, 129, 204);">[问卷调查:') !== -1) {
        havevote = 1;
      }
      // 获取投票id
      const textTemp = this.getText();
      let voteIdArr = [];
      console.log({ textTemp });
      textTemp.replace(
        /<span style="color: rgb\(0, 129, 204\);">\[问卷调查:(\S*)\]<\/span>/gi,
        (a, b) => {
          console.log({ b });
          if (b) {
            voteIdArr.push(Number(b));
          } else {
            voteIdArr = undefined;
          }
        },
      );
      console.log({ voteIdArr });
      //   return;
      // 投票处理
      const text = this.getText().replace(
        /<span style="color: rgb\(0, 129, 204\);">\[问卷调查:(\S*)\]<\/span>/gi,
        `<i voteId="$1"></i>`,
      );
      // 阻止xss攻击
      // text = text.replace(/<animate(.*?)\/animate>/g, '');

      this.getAppText();
      const req = {
        paper_id: this.paperId,
        have_paper: this.content.includes('<span style="color: rgb(0, 129, 204);">[考卷:') ? 1 : 0,
        title: this.title,
        author: this.auth,
        digest: this.textarea ? this.textarea : this.textarea_backups,
        text,
        vote_support_opt: havevote,
        external_support_opt: this.htmlType,
        external_editor_text: text,
        // app_text_pic_obj: this.getAppText().replace(
        //   /<span style="color: rgb\(0, 129, 204\);">\[问卷调查:(\S*)\]<\/span>/gi,
        //   `<i voteId="$1"></i>`,
        // ),
        cover_url: this.imageUrl,
        cover_list_url: this.imageUrl2,
        cover_media_id: JSON.stringify(this.cover_media_id),
        content_media_id: JSON.stringify(this.content_media_id),
        content_source_url: this.OldaddressText,
        show_permission: this.show_permission,
        app_ids: this.originArr.map((item) => {
          return item.app_id;
        }), // 适用公众号
        tag_product_ids: this.getArr(this.form.product), // 产品
        // product_name: this.getProName(this.form.product), // 产品名称
        department_ids: this.getArr(this.form.department), // 科室
        tag_disease_science_ids: this.getArr(this.form.disease), // 疾病科普
        tag_product_promotion_ids: this.getArr(this.form.promote), // 推广
        tag_other_ids: this.getArr(this.form.otherTag), // 其他
        status: this.status,
        valid_time_start: validTimeStart || '',
        valid_time_end: validTimeEnd || '',
        create_time: this.create_time - 0,
        update_time: this.update_time - 0,
        text_count: this.textCount - 0,
        approval_code: this.approval_code,
        Comment: this.commentControl,
      };
      console.log('请求拟毕');
      console.log(req);
      this.loading = true;
      this.dialogPublicLoading = true;
      const shit = this.$refs.labelSelect.commitTags();
      console.log(JSON.stringify(shit));
      // const fuck = shit.map((item) => JSON.stringify(item));
      console.log(String(shit));
      try {
        // 保存
        if (this.editId) {
          const newReq = {};
          for (const key in req) {
            if (key != 'Comment') {
              if (typeof req[key] === 'object') {
                newReq[key] = JSON.stringify(req[key]);
              } else {
                newReq[key] = String(req[key]);
              }
            }
          }
          // for (const key in newReq) {
          //   if (key === 'paper_id' || key === 'have_paper') {
          //     newReq[key] = Number(newReq[key]);
          //   }
          // }
          // 编辑
          await UpdArticleResApi({
            paper_id: this.paperId,
            have_paper: this.content.includes('<span style="color: rgb(0, 129, 204);">[考卷:')
              ? 1
              : 0,
            update_field: newReq,
            art_id: this.editId,
            tags: this.$refs.labelSelect.commitTags(),
            attachmentInfo: [...this.docList],
            Comment: this.commentControl,
            vote_ids: voteIdArr,
            // tags: JSON.stringify(this.$refs.labelSelect.commitTags()),
            // tags: fuck,
          });
        } else {
          // 新建
          req.tags = this.$refs.labelSelect.commitTags();
          req.attachmentInfo = [...this.docList];
          await AddArticleResApi({ art_info: { ...req, vote_ids: voteIdArr } });
        }
      } catch {
        this.loading = false;
        this.dialogPublicLoading = false;
        this.$message('文章保存失败');
      }
      this.loading = false;
      this.dialogPublicLoading = false;
      this.goBack();
    },
    getArr(val) {
      let arr = [];
      if (val) {
        const str = `${val}`;
        arr = [str];
      }
      return arr;
    },
    // 替换cos链接为公众号链接 editclass转换style内联
    replaceText(val, appTextObj) {
      let str = val;
      appTextObj = Object.assign(appTextObj, this.editStyle);
      for (const httpsUrl in appTextObj) {
        const httpUrl = httpsUrl.replace(/^https:/, 'http:');
        const wechatUrl = appTextObj[httpsUrl];
        if (wechatUrl) {
          str = str.split(httpUrl).join(wechatUrl).split(httpsUrl).join(wechatUrl);
        }
      }
      return str;
    },
    // 字符串转二进制
    strToBinary(str) {
      const result = [];
      const list = str.split('');
      for (let i = 0; i < list.length; i++) {
        if (i !== 0) {
          // 加空格，分割二进制
          result.push(' ');
        }
        const item = list[i];
        // 将字符串转化为二进制数据
        const binaryStr = item.charCodeAt().toString(2);
        result.push(binaryStr);
      }
      return result.join('');
    },
    // 获取当前时间
    getNowTime() {
      const time = new Date().getTime();
      const b = time.toString().substring(0, 10);
      return Number(b);
    },
    handleAvatarSuccess(res, file) {
      this.imageUrl = URL.createObjectURL(file.raw);
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg';
      const isLt2M = file.size / 1024 / 1024 < 1;
      if (!isJPG) {
        this.$message.error('上传头像图片只能是 JPG 格式!');
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!');
      }
      return isJPG && isLt2M;
    },
    goBack() {
      window.removeEventListener('scroll', this.handleScroll, true);
      this.$emit('changeComponet', 'articleList');
    },
    // 获取摘要
    getTextareaVal(e) {
      this.textarea = e;
      this.textareaCount = e.length;
      if (this.textareaCount === 0) {
        this.getTextCount();
      }
    },
    // 打开声明原创
    openDeclaration() {
      this.$message('打开声明原创');
    },
    // 打开原文链接
    openOldAddress() {
      this.oldAddressVisible = this.oldAddress;
    },
    // 选择原文链接
    choiceOldAddress() {
      this.oldAddress = !this.oldAddress;
      if (!this.oldAddress) {
        this.OldaddressText = '';
        this.address = '';
      }
    },
    // 弹窗确认
    OldAddressConfirm() {
      const regex = /http(s)?:\/\/([\w-]+\.)+[\w-]+(\/[\w- ./?%&=]*)?/;
      if (regex.test(this.address)) {
        this.oldAddress = true;
        this.oldAddressVisible = !this.oldAddressVisible;
        this.OldaddressText = this.address;
      } else {
        this.$message('请输入正确格式网址,例:http://XXX,链接需来源于公众号');
      }
    },
    // 弹窗取消
    OldAddressCancel() {
      if (!this.OldaddressText) {
        this.oldAddress = false;
        this.address = '';
      }
      this.oldAddressVisible = !this.oldAddressVisible;
    },
    getProName(id) {
      let name = '';
      this.productList.forEach((item) => {
        if (item.id === id) {
          name = item.product_name;
        }
      });
      return name;
    },
    // 返回顶部
    goTop() {
      const box = document.getElementsByClassName('all');
      if (this.scrollUp) {
        box[0].scrollTo({
          top: 0,
          behavior: 'smooth',
        });
      } else {
        box[0].scrollTo({
          top: 5000,
          behavior: 'smooth',
        });
      }
    },
    // 得到编辑器内容
    getContent(val) {
      // 获取字数
      this.getTextCount();

      const frag = document.createElement('div');
      frag.innerHTML = val;
      this.imgIdList = [].map.call(frag.querySelectorAll('img'), (img) =>
        img.getAttribute('mate_id'),
      );
      // this.getMaterialInfo();
      this.contentText = '';
      [].map.call(frag.querySelectorAll('p'), (p) => {
        this.contentText += p.innerText.trim();
      });

      const voteList =
        val.match(/<span style="color: rgb\(0, 129, 204\);">\[问卷调查:(\d*)\]<\/span>/gi) || [];
      const list =
        (voteList.length &&
          voteList.map((item) =>
            item.replace(
              /<span style="color: rgb\(0, 129, 204\);">\[问卷调查:(\d*)\]<\/span>/gi,
              '$1',
            ),
          )) ||
        [];
      if (list.length !== this.voteIds.lenght) {
        this.selectedVoteId = '';
      }
      this.voteIds = list;
      this.content = val;
    },
    // 得到标题
    getTitleVal(val) {
      this.title = val;
    },
    // 得到作者名称
    getAuthVal(val) {
      this.auth = val;
    },
    // 得到内容字数
    // getTextCount(val) {
    getTextCount() {
      const val = document.querySelector('.ql-editor').innerText;
      const text = val.replace(/[\r\n]/g, '');
      this.textCount = text.length;
      // 摘要备份
      if (this.textCount <= 54) {
        this.textarea_backups = text;
      } else {
        this.textarea_backups = text.slice(0, 54);
      }
    },
    // 打开图片弹窗上传
    openImage() {
      this.dialogVisible = true;
    },
    // 打开音乐
    openmusic() {
      this.musicdialog = true;
    },
    // 打开html预览
    openHtml() {
      this.htmldialog = true;
      this.htmlText = this.saveHtmlText;
    },
    // 打开html预览
    closeHtml() {
      this.htmldialog = false;
    },
    // 打开视频
    openvideo() {
      this.videodialog = true;
    },
    // 关闭图片
    closeimg() {
      this.dialogVisible = false;
    },
    // 关闭音频
    colseMusic() {
      this.musicdialog = false;
    },
    // 关闭 视频
    closeVideo() {
      this.videodialog = false;
    },
    // 打开小程序
    openSMProgram() {
      this.SMProgramDialog = true;
    },
    // 关闭小程序
    closeSMProgram() {
      this.SMProgramDialog = false;
    },
    // 图片素材库选择图片后 -- 保存
    imgSubmit(list) {
      console.log('list:', list);

      if (!list.length) {
        this.$message('请至少选择一张图片');
        this.openImage();
        return;
      }
      this.imageList = list.map((item) => {
        let wxMediaUrl = '';
        const { apps } = item;
        for (let index = 0; index < apps.length; index++) {
          const element = apps[index];
          if (element.wx_media_url) {
            wxMediaUrl = element.wx_media_url;
            break;
          }
        }
        const obj1 = {
          mate_id: item.mate_id,
          mate_name: item.mate_name,
          url: wxMediaUrl,
          mate_data: item.mate_data,
          public_list: item.apps,
          agent_list: [],
        };
        this.wechatObj.push(obj1);

        const obj2 = {};
        let url = '';
        try {
          url = item.mate_data;
        } catch (e) {
          // console.error(e);
        }
        obj2[item.mate_data] = url;
        this.appTextObj = Object.assign(this.appTextObj, obj2);
        return obj1;
      });
    },
    // 音频勾选
    musicSubmit(list) {
      this.audioList = list.map((item) => {
        // const obj = {};
        // obj[item.cos_file_url] = item.pic_net_url;
        // this.appTextObj = Object.assign(this.appTextObj, obj);
        // return item.cos_file_url;

        const publicInfo = item.apps;
        const agentInfo = [];

        const obj = {};
        obj[item.mate_data] = item.pic_net_url;
        this.appTextObj = Object.assign(this.appTextObj, obj);
        return {
          mate_id: item.mate_id,
          mate_name: item.mate_name,
          url: item.mate_data,
          public_list: publicInfo,
          agent_list: agentInfo,
        };
      });
    },
    // 视频勾选
    videoSubmit(list) {
      this.videoList = list.map((item) => {
        // const obj = {};
        // obj[item.cos_file_url] = item.wechat_material_url;
        // this.appTextObj = Object.assign(this.appTextObj, obj);
        // return item.cos_file_url;
        // console.log(item);
        const publicInfo = item.apps;
        const agentInfo = [];

        const obj = {};
        obj[item.mate_data] = item.pic_net_url;
        this.appTextObj = Object.assign(this.appTextObj, obj);
        return {
          mate_id: item.mate_id,
          mate_name: item.mate_name,
          url: item.mate_data,
          public_list: publicInfo,
          agent_list: agentInfo,
        };
      });
    },
    // 小程序确认
    SMProgramSubmit(e) {
      this.smProgramLink = e;
    },
    // 选择列表封面
    selectImg() {
      this.coverType = 1;
      this.selectImgVisible = true;
    },
    // 选择文章封面
    selectImg2() {
      this.coverType = 2;
      this.selectImgVisible = true;
    },

    // 标准时间转时间戳
    dateToMs(date) {
      const result = new Date(date).getTime();
      return result / 1000;
    },
    // 选择封面关闭
    closeSelectimg() {
      this.selectImgVisible = false;
    },
    // 必须勾选一张图片
    selectImgSubmit(list) {
      if (!list.length) {
        this.$message('请至少选择一张图片');
        this.selectImgVisible = true;
        return;
      }
      if (this.coverType === 1) {
        this.imageUrl = list[0].mate_data;
        this.cover_media_id[0] = {
          id: list[0].mate_id,
          mate_name: list[0].mate_name,
          mate_data: list[0].mate_data,
          mate_type: 1,
          public_list: list[0].apps,
        };
      } else {
        this.imageUrl2 = list[0].mate_data;
        this.cover_media_id[1] = {
          id: list[0].mate_id,
          mate_name: list[0].mate_name,
          mate_data: list[0].mate_data,
          mate_type: 1,
          public_list: list[0].apps,
        };
      }
    },
    beforeDestroy() {
      window.removeEventListener('scroll', this.handleScroll, true);
    },
    changeShowPermission(number) {
      this.show_permission = number;
    },
    // 得到字符串含有某个字符的个数

    getCharCount(str, char) {
      const regex = new RegExp(char, 'g'); // 使用g表示整个字符串都要匹配
      let result = str.match(regex); // match方法可在字符串内检索指定的值，或找到一个或多个正则表达式的匹配。
      result = !result ? [] : result;
      return result;
    },
    /* 点击选择投票 */
    votling() {
      const { content } = this;
      const arr = this.getCharCount(
        content,
        /<span style="color: rgb\(0, 129, 204\);">\[问卷调查:(\S*)\]<\/span>/gi,
      );
      this.voteIds = arr.map((item) => {
        return item.replace(
          /<span style="color: rgb\(0, 129, 204\);">\[问卷调查:(\S*)\]<\/span>/gi,
          `$1`,
        );
      });

      this.htmldialogLoading = false;
      this.loading = false;
      this.isSelectVoteShow = true;
    },
    closeVoteMe() {
      this.isSelectVoteShow = false;
    },
    upSelectedVoteId(id) {
      this.voteIds ? '' : (this.voteIds = []);
      const listIds = this.voteIds;
      !listIds.includes(id) && this.voteIds.push(id);
      this.selectedVoteId = id;
      this.isSelectVoteShow = false;
    },
    newVoteId() {
      this.isSelectVoteShow = false;
      this.addVotingShow = true;
    },
    // 关闭新建投票
    addVotingShowEmit() {
      this.isSelectVoteShow = true;
      this.addVotingShow = false;
    },
    closeShowMedia() {
      this.isShowDlete = false;
    },
    affirmShowMedia() {
      this.isShowDlete = false;
      // 继续保存
      if (this.isShowMedia) {
        this.publicVisible = true;
      } else {
        this.confirmForm('form');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
input {
  border: 0;
  outline: none;
  background: none;
}
.all {
  width: 100%;
  height: 100%;
  font-size: 16px;
  overflow: auto;
  background: rgb(245, 245, 245);
  .suspend-btn {
    width: 116px;
    height: 40px;
    background: #ffffff;
    box-shadow: 0 3px 8px 0 rgba(0, 0, 0, 0.08);
    border-radius: 20px;
    position: absolute;
    top: 84%;
    right: 3%;
    cursor: pointer;
    .suspend-icon {
      height: 16px;
      width: 16px;
      margin: 13px 14px;
    }
    .scroll-img-down {
      transform: rotate(180deg);
      transition: all 0.5s;
    }
    .scroll-img-up {
      transform: rotate(0deg);
      transition: all 0.5s;
    }
    .suspend-word {
      top: 10px;
      left: 38px;
      display: inline-block;
      font-size: 16px;
      position: absolute;
      color: #909399;
    }
  }
  .box-header {
    height: 80px;
    padding: 37px 23px 21px;
    color: #606266;
    border-bottom: 1px solid rgba(0, 0, 0, 0.08);
    background: #fff;
    .header-back {
      cursor: pointer;
      display: inline-block;
      .el-icon-arrow-left {
        font-weight: bold;
      }
    }
    .header-back:hover {
      color: rgb(47, 150, 255);
    }
  }
  .box-bg {
    width: 100%;
    background: #fff;
    .box-bar {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 74px;
      padding: 16px 98px;
      background: #ffffff;
      min-width: 890px;
      max-width: 1200px;
      margin: 0 auto;
      text-align: center;
      .bar-bg {
        height: 100%;
        background-color: rgba($color: #f5f7fa, $alpha: 0.65);
        border-radius: 8px;
        display: inline-flex;
        justify-content: space-around;
        line-height: 39px;
        &.addVote {
          margin-right: 16px;
          padding: 0 16px;
        }
        .bar-item {
          cursor: pointer;
          color: #303133;
          line-height: 44px;
        }
        .bar-item:hover {
          cursor: pointer;
          color: rgb(47, 150, 255);
        }
      }
      .bar-left {
        margin-right: 16px;
        padding: 0 16px;
      }
      .bar-right {
        width: 136px;
      }
      .bar-bgg {
        height: 100%;
        background-color: rgba($color: #f5f7fa, $alpha: 0.65);
        border-radius: 8px;
        display: inline-flex;
        justify-content: space-around;
        line-height: 39px;
        .box {
          display: flex;
          justify-content: center;
          align-items: center;
          .bar-item {
            cursor: pointer;
            color: #303133;
            line-height: 44px;
          }
          .log-automatic {
            margin-left: 10px;
            color: #303133;
          }
          .bar-item:hover {
            cursor: pointer;
            color: rgb(47, 150, 255);
          }
        }
      }
      .bar-leftt {
        width: 192px;
        margin-right: 16px;
      }
    }
  }
  .box-body {
    color: rgb(245, 245, 245);
    background-color: rgb(245, 245, 245);
    // height: 102%;
    .body-edit {
      width: 100%;
      color: #333;
    }
    .body-content {
      border-radius: 8px;
      min-width: 890px;
      max-width: 1200px;
      margin: 0 auto;
      .content {
        // border-top: 1px solid rgba(0,0,0,0.08);
        // border-bottom: 1px solid rgba(0,0,0,0.08);
        padding: 12px 100px 26px;
        background-color: #ffffff;
        .content-box {
          border-top: 1px solid rgba(0, 0, 0, 0.08);
          padding-top: 12px;
          border-bottom: 1px solid rgba(0, 0, 0, 0.08);
          padding-bottom: 66px;
          .content-box-header {
            color: #303133;
            font-weight: bold;
            height: 22px;
            line-height: 22px;
            margin-bottom: 16px;
          }
          .content-box-header-top {
            color: #303133;
            font-weight: bold;
            height: 22px;
            line-height: 22px;
            margin-bottom: 16px;
            margin-top: 8px;
          }

          .box-main {
            width: 100%;
            display: flex;
            ::v-deep .el-upload {
              width: 100%;
              height: 100%;
              .avatar-uploader-icon {
                width: 100%;
              }
              span.upload-word {
                width: 80px;
              }
              img.avatar {
                width: 100%;
                height: 100%;
              }
            }
            .avatar-uploader ::v-deep .el-upload {
              border: 1px dashed #dcdfe6;
              border-radius: 8px;
              cursor: pointer;
              position: relative;
              overflow: hidden;
            }
            .avatar-uploader ::v-deep .el-upload:hover {
              border-color: #409eff;
            }
            .avatar-uploader-icon {
              font-size: 28px;
              color: #2f96ff;
              width: 160px;
              height: 90px;
              line-height: 74px;
              text-align: center;
              position: relative;
              .upload-word {
                position: absolute;
                top: 72%;
                left: 50%;
                transform: translate(-50%, -50%);
                font-size: 14px;
                color: #2f96ff;
              }
            }
            .avatar {
              width: 160px;
              height: 90px;
              display: block;
            }
            .input-box {
              position: relative;
              flex: 1;
              .avatar-word {
                margin-left: 16px;
                height: 100%;
              }
              .avatar-word ::v-deep .el-textarea__inner {
                height: 94px;
                border: 1px solid #dcdfe6;
                border-radius: 8px;
                padding: 8px 16px;
                line-height: 22px;
                font-size: 16px;
              }
              .avatar-word ::v-deep .el-textarea__inner::placeholder {
                color: #ccc;
              }
              .word-count {
                color: rgba(0, 0, 0, 0.4);
                position: absolute;
                right: 0;
                bottom: 10px;
                font-size: 16px;
              }
            }
            .declaration {
              width: 80px;
              height: 32px;
              line-height: 32px;
              text-align: center;
              border: 1px solid #2f96ff;
              border-radius: 8px;
              font-size: 14px;
              color: #2f96ff;
              cursor: pointer;
            }
            .article-settings {
              cursor: pointer;
              color: #303133;
              outline: none;
              white-space: nowrap;
              overflow: hidden;
              .article-choice {
                height: 16px;
                width: 16px;
                margin-right: 8px;
              }
              .old-address {
                font-size: 16px;
                position: relative;
                top: -2px;
                display: inline-block;
              }
              .el-icon-arrow-right {
                font-size: 16px;
                margin-right: 8px;
                position: relative;
                top: -2px;
              }
              .address {
                color: #909399;
                display: inline-block;
                white-space: nowrap;
                width: 880px;
                overflow: hidden;
                text-overflow: ellipsis;
                line-height: 14px;
              }
            }
            .edit-form {
              width: 100%;
              .edit-label {
                width: 100%;
                .edit-select {
                  width: 400px;
                }
              }
            }
            .authority-box {
              height: 22px;
              width: 100%;
              .authority-box-part {
                width: 184px;
                color: #000000;
                cursor: pointer;
                display: inline-flex;
              }
            }
            .comment-box {
              height: 22px;
              width: 100%;
              margin-bottom: 16px;
              .comment-type {
                width: 184px;
                color: #000000;
                height: 20px;
                display: inline-flex;
                .comment-word {
                  height: 10%;
                  font-size: 14px;
                }
              }
              .comment-box-part {
                width: 184px;
                height: 20px;
                cursor: pointer;
                display: inline-flex;
              }
            }
          }
          .column {
            flex-direction: column;
          }
          .warn-img {
            color: rgba(255, 0, 0, 0.85);
            margin-top: 8px;
          }
          .margin-top {
            margin-top: 43px;
          }
          .margin-top-purview {
            margin-top: 21px;
          }
        }
      }
      .body-content-footer {
        padding: 24px 0;
        height: 80px;
        display: flex;
        justify-content: space-between;
        background: #ffffff;
        margin-bottom: 29px;
        .textCount {
          line-height: 40px;
          margin-left: 20px;
          font-size: 14px;
          color: rgba(0, 0, 0, 0.45);
        }
        .saveAll {
          text-align: center;
          height: 40px;
          line-height: 40px;
          width: 100px;
          font-weight: bold;
          background: #2f96ff;
          border-radius: 8px;
          margin-right: 100px;
          cursor: pointer;
        }
        .saveAll:hover {
          background: #63b0ff;
          color: #ffffff;
        }
      }
    }
  }
}
.weight-blod {
  margin-top: 43px;
}
.weight-blod ::v-deep .el-form-item__label {
  font-weight: bold;
  display: contents;
}
.weight-blod ::v-deep .el-form-item__error {
  padding-left: 14px;
}
.othor-editor {
  ::v-deep .el-dialog {
    border-radius: 20px !important;
  }
}
.footer-content {
  display: flex;
  justify-content: center;
  .html-btn {
    margin-right: 37px;
    height: 100%;
    flex: 1;
    display: flex;
    justify-content: center;
  }
}
.checkbox-color {
  color: #409eff;
}
.address-popover {
  .popover-box {
    padding: 24px 48px;
    .popover-title {
      margin-top: 12px;
      font-size: 18px;
      margin-bottom: 24px;
    }
    .popover-input {
      width: 100%;
      margin-bottom: 12px;
      .el-input__inner {
        width: 100%;
      }
    }
    .popover-footer {
      text-align: center;
      .el-button {
        width: 110px;
        height: 40px;
      }
    }
  }
}
.el-button--primary {
  background: #2f96ff;
  border-color: unset;
}
.el-button--primary:hover {
  background: #2f8fff;
  border-color: unset;
}
.el-button--primary:focus {
  background: #2f96ff;
  border-color: unset;
}
.el-button--default:hover {
  border-color: #2f96ff;
  span {
    border-color: #2f96ff;
  }
}
.el-form-item.is-required .el-form-item__label:before {
  vertical-align: inherit;
}
.el-form-item ::v-deep .el-form-item__content {
  margin-left: 0 !important;
  // width: 320px;
}
// .el-select .el-input .el-select_caret.is-show-close::after{
//     display: none;
// }
// .el-select .el-input .el-select__caret.is-reverse{
//   transform: rotateZ(180deg);
// }
.el-input__icon:hover {
  line-height: 20px;
}
.el-input__icon {
  line-height: 20px;
}
.edit-label ::v-deep .el-date-editor .el-range__close-icon {
  line-height: unset;
  position: absolute;
  float: unset;
  right: 10px;
}
// .edit-label ::v-deep .el-date-editor .el-range__icon{
//     right: 16px;
// }
//.edit-label ::v-deep.el-range-separator {
//margin-right: 38px;
//}
// .el-form-item.is-required:not(.is-no-asterisk)>.el-form-item__label:before{
//     content:unset !important;
// }
.weight-blod ::v-deep .el-form-item__label:before {
  content: unset !important;
}
.el-date-editor--daterange.el-input,
.el-date-editor--daterange.el-input__inner,
.el-date-editor--timerange.el-input,
.el-date-editor--timerange.el-input__inner {
  width: 320px;
}
// .weight-blod ::v-deep .el-range-editor.el-input__inner{
//     position: absolute;
//     top: 53px;
//     left: -89px
// }

.ui-editor-progress {
  margin: 0px auto;
  margin-bottom: 10px;
  width: 350px;
}
.dialog-public ::v-deep .el-dialog__header {
  padding: 20px 20px 10px;
  .el-dialog__close {
    &::before {
      content: '\e6db';
    }
  }
}
.dialog-public ::v-deep .el-dialog__footer {
  text-align: center;
}
.public-dialog-body {
  font-size: 18px;
  h4 {
    margin-bottom: 15px;
  }
  img {
    width: 188px;
    height: 80px;
    border-radius: 8px;
  }
  video {
    width: 188px;
    height: 80px;
    border-radius: 8px;
  }
}
.el-dialog {
  border-radius: 15px;
}

.icon-wenhao {
  width: 18px;
  height: 18px;
  cursor: pointer;
}
</style>
